type HandoffLocation = Pick<Location, "hash" | "pathname" | "search">;
type HandoffHistory = Pick<History, "replaceState" | "state">;

export type AuthSessionHandoff = {
  accessToken: string;
  refreshToken: string;
  expiresAt: number;
  user: unknown;
};

function removeHandoffValue(
  key: string,
  location: HandoffLocation,
  history: HandoffHistory,
): string | null {
  const handoff = new URLSearchParams(location.hash.replace(/^#/, ""));
  if (!handoff.has(key)) return null;

  const value = handoff.get(key);
  handoff.delete(key);
  const remainingHash = handoff.toString();
  history.replaceState(
    history.state,
    "",
    `${location.pathname}${location.search}${remainingHash ? `#${remainingHash}` : ""}`,
  );
  return value;
}

export function consumeAuthCode(
  location: HandoffLocation,
  history: HandoffHistory,
): string | null {
  return removeHandoffValue("auth_code", location, history);
}

export function consumeAuthSession(
  location: HandoffLocation,
  history: HandoffHistory,
): AuthSessionHandoff | null {
  const value = removeHandoffValue("auth_session", location, history);
  if (!value) return null;

  try {
    const session: unknown = JSON.parse(value);
    if (
      !session ||
      typeof session !== "object" ||
      typeof (session as AuthSessionHandoff).accessToken !== "string" ||
      typeof (session as AuthSessionHandoff).refreshToken !== "string" ||
      typeof (session as AuthSessionHandoff).expiresAt !== "number"
    ) {
      return null;
    }
    return session as AuthSessionHandoff;
  } catch {
    return null;
  }
}
